import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@joyful/utils'

import { Header } from '../header'
import { PageMain, pageMainVariants } from '../page-main'
import { Separator } from '../Separator'

export { Header as RouteHeroSectionHeader }
export { Separator as RouteLayoutSeparator }
export type RouteLayoutProps = { children: ReactNode } & Pick<
  ComponentProps<typeof PageMain>,
  'ref'
>

export function RouteLayout({ children, ref }: RouteLayoutProps) {
  return (
    <PageMain ref={ref} grow="fill" padding="none" position="relative">
      {children}
    </PageMain>
  )
}

export interface RouteHeroSectionProps {
  children: ReactNode
  className?: string
}

export function RouteHeroSection({
  children,
  className,
}: RouteHeroSectionProps) {
  return (
    <section
      className={cn(
        pageMainVariants({
          background: 'warm',
          padding: 'page',
          position: 'relative',
        }),
        'pb-0!',
        className,
      )}
    >
      {children}
    </section>
  )
}

export interface RouteErrorStateProps extends ComponentProps<'div'> {
  description: string
  title: string
}

export function RouteErrorState({
  description,
  title,
  ...props
}: RouteErrorStateProps) {
  return (
    <div
      className="flex w-full flex-row items-center justify-center"
      {...props}
    >
      <div className="flex max-w-5xl flex-col-reverse items-center gap-y-4 p-8 sm:flex-row">
        <div className="flex shrink-0 grow-0 flex-col gap-y-2.5 p-8 sm:w-1/2">
          <h1 className="text-tremor-content-emphasis text-2xl font-semibold">
            {title}
          </h1>
          <p className="text-tremor-content text-balance">{description}</p>
        </div>

        <img
          alt="Joyful Health Error"
          className="w-1/2 shrink-0 grow-0 sm:w-1/3"
          src="/images/error2.webp"
        />
      </div>
    </div>
  )
}
